module.exports = __webpack_public_path__ + "assets/img/g1.52349943.jpg";